export const INVENTORIZE_REVIEW_STATUSES = {
  accepted: 'accepted',
  empty: 'empty',
  manual: 'manual',
  parsed: 'parsed',
  unsure: 'unsure',
  waived: 'waived',
} as const;

export type InventorizeReviewStatus = (typeof INVENTORIZE_REVIEW_STATUSES)[keyof typeof INVENTORIZE_REVIEW_STATUSES];
